import fr from "@/locales/fr";
import en from "@/locales/en";
const translations: any = {
  fr,
  en,
};

// Détecte ou retourne les traductions par langue
export default translations
